import { Box } from '@indoqa/style-system';
import * as React from 'react';
import { FelaComponent } from 'react-fela';
import { withUIETheme } from '../uietheme/withUIETheme';
const toHexString = (color) => {
    return color.startsWith('#') ? color.substr(1) : color;
};
const calcTextColor = (color) => {
    if (!color) {
        return '#fff';
    }
    const bigint = parseInt(toHexString(color), 16);
    const red = (bigint >> 16) & 255;
    const green = (bigint >> 8) & 255;
    const blue = bigint & 255;
    return red * 0.299 + green * 0.587 + blue * 0.114 > 180 ? '#000' : '#fff';
};
const ColorPanelInternal = ({ color, name, uieTheme }) => {
    const textColor = calcTextColor(color);
    const style = {
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        minWidth: '12rem',
        height: '7rem',
        backgroundColor: color,
        textAlign: 'center',
        textTransform: 'uppercase',
        padding: uieTheme.spacing.space1,
        marginRight: uieTheme.spacing.space2,
        marginBottom: uieTheme.spacing.space2,
        borderRadius: '3px',
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: uieTheme.colors.borderPanel,
    };
    return (React.createElement(FelaComponent, { style: style },
        React.createElement(Box, { style: {
                ...uieTheme.fontStyles.base,
                color: textColor,
                fontSize: uieTheme.fontSizes.small,
                marginBottom: 'auto',
            } }, name),
        React.createElement(Box, { style: {
                ...uieTheme.fontStyles.base,
                color: textColor,
                fontSize: uieTheme.fontSizes.verySmall,
            } }, color)));
};
export const ColorPanel = withUIETheme(ColorPanelInternal);
//# sourceMappingURL=ColorPanel.js.map